jQuery(document).ready(function () {
  console.log("document is ready.......");

  $(".new-template .filter-icon > span").click(function () {
    $(".new-template .sidebar-overlay").removeClass("hide");
  });

  $(
    ".new-template .sidebar-overlay, .new-template span.filter-cross_icon"
  ).click(function () {
    $(".new-template .sidebar-overlay").addClass("hide");
  });

  let sortWidth = $(".sort-icon").width();
  $(
    ".new-template-counter-desktop .product-filter .list-options #sort-by"
  ).width(sortWidth);

  $(".view-count .pd_view").text(
    $(".new-template .products-on-page .product-item").length
  );

  window.addEventListener("scroll", (event) => {
    let scroll = window.scrollY;
    let bottomHeight = document.body.scrollHeight - scroll;

    if (
      500 < scroll &&
      bottomHeight > 1850 &&
      !$("body").hasClass("scroll-body")
    ) {
      // console.log(scroll, 'scroll');
      $("body").addClass("scroll-body");
    } else if (
      (500 > scroll && $("body").hasClass("scroll-body")) ||
      (bottomHeight < 1850 && $("body").hasClass("scroll-body"))
    ) {
      $("body").removeClass("scroll-body");
    }
  });

  $(".read_more-btn").unbind("click");
  $(".read_more-btn").click(function (e) {
    if ($(e.target).text() == "READ MORE") {
      $(".templateCollection .desc-container").addClass("show_more");
      $(e.target).text("READ LESS");
    } else {
      $(".templateCollection .desc-container").removeClass("show_more");
      $(e.target).text("READ MORE");
    }
  });

  // hiding the discover more button based on next pagination URL
  if ($(".pagination a.next").attr("href") === "") {
    $(".fastor_ajax_load_button").hide();
  } else {
    $(".fastor_ajax_load_button").show();
  }

  let minWidth = 991;
  if (
    !(window.innerWidth < minWidth || screen.width < minWidth) &&
    $.fn.slick !== "undefined"
  ) {
    // Slick Slider function here
    $(".collection-redesign .color_variant.color-slide").slick({
      dots: false,
      infinite: false,
      arrows: false,
      slidesToShow: 11,
      slidesToScroll: 1,
      centerPadding: "10px",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // 'Add to Wishlist' datalayer push

  $(".swym-add-to-wishlist-view-product.solo-product").click(function () {
    if (!$(this).hasClass("swym-added")) {
      let pdName = $(this).parents(".product-item").find(".name a").text();
      let pdIndex = $(this).index(".swym-add-to-wishlist-view-product");
      let pdPr = $(this).data("pd-price")?.replace("£", "");

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          currency: "GBP", //the user's currency
          value: pdPr, //the product price
          items: [
            {
              item_id: $(this).data("variant-id"), // the
              item_name: pdName, //the product name
              index: pdIndex + 1, //the position
              item_brand: "daals",
              item_category: $(this).data("pd-category"),
              item_list_name: location.pathname, //dynamic, the list name
              item_variant: "Default Title", //dyanmic, the variant added to wish list
              item_product_id: $(this).data("product-id"),
              item_variant_id: $(this).data("variant-id"),
              price: pdPr, //the price of the product, same as the value
              quantity: 1, //always static and 1
            },
          ],
        },
      });
    }
  });
});
